import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  viewChild,
} from '@angular/core';
import {
  RdsButtonComponent,
  RdsCellDefDirective,
  RdsCellDirective,
  RdsColumnDefDirective,
  RdsHeaderCellDefDirective,
  RdsHeaderCellDirective,
  RdsHeaderRowComponent,
  RdsHeaderRowDefDirective,
  RdsPaginatorComponent,
  RdsRowComponent,
  RdsRowDefDirective,
  RdsTableComponent,
  RdsTableDataSource,
} from '@rds/angular-components';
import jsonToCsvExport from 'json-to-csv-export';

import { BookingChartDataDTO } from '@bookly/shared';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bsh-bookings-table',
  templateUrl: './bookings-table.component.html',
  styleUrl: './bookings-table.component.scss',
  imports: [
    DatePipe,
    RdsButtonComponent,
    RdsTableComponent,
    RdsColumnDefDirective,
    RdsHeaderCellDirective,
    RdsHeaderCellDefDirective,
    RdsCellDefDirective,
    RdsCellDirective,
    RdsHeaderRowComponent,
    RdsHeaderRowDefDirective,
    RdsRowComponent,
    RdsRowDefDirective,
    RdsPaginatorComponent,
  ],
})
export class BookingsTableComponent implements AfterViewInit {
  protected readonly displayedColumns: string[] = [
    'id',
    'eventName',
    'startTime',
    'endTime',
    'createTime',
    'numberOfPeople',
    'roomType',
    'roomName',
    'services',
    'status',
  ];
  protected readonly datasource =
    new RdsTableDataSource<BookingChartDataDTO>().init();
  protected readonly paginator = viewChild(RdsPaginatorComponent);

  @Input() set bookingsData(value: BookingChartDataDTO[] | null) {
    this.datasource.data = value ?? [];
  }

  ngAfterViewInit(): void {
    this.datasource.paginator = this.paginator() as RdsPaginatorComponent;
  }

  exportToCSV() {
    jsonToCsvExport({
      data: this.datasource.data,
      filename: 'bookings_data',
      delimiter: ',',
    });
  }
}
